export default {
  root: '/',
  main: '/main',
  report: '/report'
}